module.exports = __webpack_public_path__ + "static/img/gl.05073911.svg";